import React from 'react';
import styled from 'styled-components';
import { fontUbuntuLight } from '../../utilities/utilities';

const OrderedList = styled.ol`
    color: ${props => props.textColor ? props.textColor : '#0d1b58'};
    font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
    list-style-type: none;
    counter-reset: item;
    margin: 0;
    padding: 0;
    margin-top: 0.5rem;

    & > li {
        display: table;
        counter-increment: item;
        margin-bottom: 0.5rem;
        width: 100%
    }

    & > li:before {
        content: counters(item, ".") ". ";
        display: table-cell;
        padding-right: 0.6em;    
        width:12px;
    }
`
const OrderedListItem = styled.li`
    color: ${props => props.textColor ? props.textColor : 'inherit'};
    font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
    font-weight: ${ props => props.bold ? 700 : 500 };
    & ol > li {
        margin: 0;
        margin-bottom: 0.5rem;
    }

    & ol > li:before {
        content: counters(item, ".") " ";
    }
`;

// const TermsListGroup = styled.ul`
//     list-style: none;
//     margin-top: 0.5rem;
// `;
// const TermsListItem = styled.li`
//     font-weight: ${ props => props.bold ? 700 : 500 };
//     margin-bottom:0.5rem;
// `;

const TermsHeading = styled.strong`

`
const NumberList = (props) => {
    let NumberedItem =  Object.keys(props.list.terms).map((element, index) => {
         return   <OrderedListItem>{props.list.terms[element].text}{props.list.terms[element].terms &&  <NumberList list={props.list.terms[element]} appState={props.appState} />}</OrderedListItem>
    })

return (
        <OrderedListItem bold fontFamily={props.appState.ui.terms.card.fontFamily} textColor={props.appState.ui.terms.card.titleTextColor}><TermsHeading>{props.list.title}</TermsHeading>
            <OrderedList>
                {NumberedItem}
            </OrderedList>
        </OrderedListItem>
    )
}

export default NumberList;


// WEBPACK FOOTER //
// ./src/components/Lists/NumberedList.js